/**
 * getAmplienceContentByDeliveryKey utility
 *
 * Purpose:
 * - This function fetches Amplience content using a given delivery key via the Frontastic action system.
 * - Handles error scenarios gracefully by throwing meaningful errors if the delivery key is missing or the API call fails.
 *
 * Usage:
 * - Import and call this function with a valid delivery key string.
 * - Used by React components or server-side functions to retrieve structured content from Amplience.
 *
 * Example:
 * const content = await getAmplienceContentByDeliveryKey('some/delivery/key');
 */

import { sdk } from 'sdk';

export async function getAmplienceContentByDeliveryKey(deliveryKey: string) {
  if (!deliveryKey) throw new Error('Delivery key is required');

  const response = await sdk.callAction<any>({
    actionName: 'amplience/getContentByDeliveryKey',
    query: { deliveryKey },
  });

  if (response.isError) {
    const message =
      typeof response.error?.message === 'string' ? response.error.message : 'Failed to fetch Amplience content';
    throw new Error(message);
  }

  return response.data;
}
